import { render } from "./Guest.vue?vue&type=template&id=0240c39b"
import script from "./Guest.vue?vue&type=script&lang=js"
export * from "./Guest.vue?vue&type=script&lang=js"

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Guest.vue"]])

export default __exports__